<template>

<form v-on:submit.prevent="create()" class="modal-card" style="min-width: 10em;">
    
    <section class="modal-card-body">
        <h1 class="title is-4">
            ▶️ Setup your model training
        </h1>
        <h1 class="subtitle">
            Here you can control the speed and quality of the learning process that occurs during model training. 
            Check the docs:
            <a href="https://docs.metatext.ai/v1/getting-started/training/training-parameters" target="_blank">🔗 Training Parameters</a>
        </h1>
        <br>
        <b-notification
            v-if="!hasEnoughCredits()"
            type="is-info"
            has-icon>
            Sorry, there's no credits available for a new training version.<br>
            Your current model will still be automatically updated when you <b>annotate or add new records</b>.
        </b-notification>
        <b-button class="is-pulled-right" type="is-primary" tag="router-link" :to="'/d/pricing'">
                <i class="fa fa-plus"></i> Add credits
            </b-button>
        <b-field label="Training cost" message="Preview of how much your training will cost">
            
            <p class="is-size-5">
                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"/></svg>
                {{ creditsNeeded() }} credits ({{ availableCredits() }} credits available)<br>
            </p>
            
        </b-field>
        
        <!-- <b-field label="Language" message="Choose the main language of your dataset">
            <b-select v-model="modelLanguage" size="is-medium" name="language" required expanded  placeholder="Choose a language">
                <option value='Multilingual' selected>Multilingual</option>
                <option v-for="l in ['English', 'Mandarin / Chinese', 'Hindi', 'Spanish', 'Portuguese', 'French', 'Arabic', 'Other - Multilingual']" :value="l">{{ l }}</option>
            </b-select>
        </b-field> -->

        <a target="_blank" href="https://huggingface.co/models?library=sentence-transformers" v-if="project.type == 'classification'">Please refer to the library for supported model base</a>
        <a target="_blank" href="https://huggingface.co/models?library=gliner" v-else-if="project.type == 'extraction'">Please refer to the library for supported model base</a>
        <a target="_blank" href="https://huggingface.co/models?pipeline_tag=text-generation" v-else>Please refer to the library for supported model base</a>
        
        <b-field label="Model base" message="Default is BAAI/bge-small-en-v1.5" v-if="project.type == 'classification'">
            <b-input v-model="modelBase" size="is-medium" placeholder="BAAI/bge-small-en-v1.5" expanded></b-input>
        </b-field>
        <b-field label="Model base" message="Default is urchade/gliner_small" v-else-if="project.type == 'extraction'">
            <b-input v-model="modelBase" size="is-medium" placeholder="urchade/gliner_small" expanded></b-input>
        </b-field>
        <b-field label="Model base" message="Default is meta-llama/Llama-3-8B" v-else>
            <b-input v-model="modelBase" size="is-medium" placeholder="meta-llama/Llama-3-8B" expanded></b-input>
        </b-field>
            
        
        <b-field label="Hardware accelerator" message="Select the hardware training capacity">
            <b-select v-model="modelSize" size="is-medium" placeholder="Select a size" expanded>
                <optgroup>
                    <option value="small">Small</option>
                    <option value="medium">
                        Medium
                    </option>
                    <option value="large" :disabled="!isProPlan()">
                        Large
                        <b-tag v-if="!isProPlan()" type="is-dark">(Available on PRO plan)</b-tag>
                    </option>
                    <!-- <option value="mistral" disabled>Mistral 7B (Coming soon)</option>
                    <option value="mistral" disabled>LLama 2 70B (Coming soon)</option> -->
                    <!-- <option value="roberta" disabled>RoBERTa</option>
                    <option value="mistral" disabled>Mistral 7B</option>
                    <option value="gpt35" disabled>GPT-3.5 Turbo</option> -->
                </optgroup>
            </b-select>
            
        </b-field>

        
        <!-- slide from 0 to 10 to select the speed parameter -->
        <!-- <b-field  :label="!isProPlan() ? 'Trials (Available only on PRO plan)': 'Trials'" message="Choose the quantity of models for training. Trials indicate the training speed, with 1 trial being quick training (less than 10 minutes) and 10 trials signifying extended training (over 1 hour).">
            <b-slider :disabled="!isProPlan()" v-model="modelTrials" :step="1" :min="1" :max="10" size="is-medium" name="speed" required expanded>
                <template slot="tooltip" slot-scope="props">
                    {{ props.value }}
                </template>
            </b-slider>
        </b-field> -->
        
    </section>
    <footer class="modal-card-foot">
        <b-button
            label="Close"
            @click="$emit('close')" />
        <b-button
            tag="button"
            :disabled="!hasEnoughCredits()"
            @click="create()"
            type="is-primary"
            expanded>
            Run (
                
                {{ creditsNeeded() }} credits
            )
        </b-button>
            
    </footer>
</form>
</template>
<script>
import mixin from '@/utils/sharedFunctions.js'

export default {
    mixins: [mixin],
   props: ["project", "currentUser", "rowsLength"],
  data() {
    return {
      radio: 'binary',
      dataset: null,
      modelType: 'binary',
      modelBase: null,
      modelLanguage: 'Multilingual',
      modelSize: 'small',
      modelTrials: 1,
      trainingModels: 2,
      isFinished: false,
      selectedDataset: [],
      modelSizePrice: {
        small: 1, 
        medium: 2, 
        large: 4
      },
    };
  },
  created() {
    if (this.project.type == 'classification'){
        this.modelBase = 'BAAI/bge-small-en-v1.5'
    } else if (this.project.type == 'extraction'){
        this.modelBase = 'urchade/gliner_small'
    } else {
        this.modelBase = 'meta-llama/Llama-3-8B'
    }
  },
  computed: {
    datasets() {
        return [...this.$store.state.datasets, ...this.$store.state.publicDatasets]
    }
  },
  methods: {
        
    },
    
}
</script>